<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Vessel Holiday Calenders &nbsp;
          <add-button
            link="/rest-hours-management/vessel-holiday-calendars/create"
          ></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Rest Hours Management</li>
          <li class="breadcrumb-item">Vessel Holiday Calenders</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Export To Excel -->
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4">
                <div style="float: right">
                  <a
                    href="#"
                    class="btn btn-primary"
                    v-if="Exportvessel_holiday_calendars.length == 0"
                    @click="exportToExcel"
                  >
                    <span v-if="isExcelloading">
                      <div class="d-flex align-items-center">
                        <strong>Generating Excel</strong>
                        &nbsp;
                        <div
                          class="
                            spinner-border
                            text-light
                            spinner-border-sm
                            ms-auto
                          "
                          role="status"
                          aria-hidden="true"
                        ></div>
                      </div>
                    </span>
                    <span v-else>Generate Excel</span>
                  </a>
                  <download-excel
                    :title="title"
                    v-else
                    class="btn btn-success"
                    :data="vessel_holiday_calendars_excel"
                    :fields="excel_fields"
                    worksheet="Vessel Holiday Calenders"
                    name="Vessel Holiday Calender.xls"
                    >Download Excel
                  </download-excel>
                </div>
              </div>
            </div>
            <br />
            <!-- End Export to Excel -->
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Vessel</th>
                    <th>Holiday Calender Name</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="8
                        "
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="vessel_holiday_calendars.length == 0">
                    <td colspan="8" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr
                    v-for="(
                      vessel_holiday_calender, at
                    ) in vessel_holiday_calendars"
                    :key="`vessel_holiday_calender${at}`"
                  >
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>{{ vessel_holiday_calender.vessel.name }}</td>
                    <td>{{ vessel_holiday_calender.holiday_calendar.name }}</td>
                    <td>
                      <div>
                        <router-link
                          :to="`/rest-hours-management/vessel-holiday-calendars/${vessel_holiday_calender.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(vessel_holiday_calender.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "vessel_holiday_calender",
  data() {
    return {
      vessel_holiday_calendars: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      vessel_holiday_calendars_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        Vessel: "vessel",
        "Holiday Calender Name": "holiday_calender_name",
      },
      Exportvessel_holiday_calendars: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let vessel_holiday_calendars = await axios.get(
        `/vessel_holiday_calendars?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.vessel_holiday_calendars = vessel_holiday_calendars.data.data;
      this.count = vessel_holiday_calendars.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let vessel_holiday_calendars = await axios.get(
        `/vessel_holiday_calendars?search=${this.searchData}`
      );
      this.vessel_holiday_calendars = vessel_holiday_calendars.data.data;
      this.count = vessel_holiday_calendars.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "Vessel Holiday Calender Data";
      this.vessel_holiday_calendars_excel = [];
      let Exportvessel_holiday_calendars = [];
      Exportvessel_holiday_calendars = await axios.get(
        `/vessel_holiday_calendars`
      );
      this.Exportvessel_holiday_calendars =
        Exportvessel_holiday_calendars.data.data;
      let sr_no = 1;
      this.Exportvessel_holiday_calendars.forEach((vessel_holiday_calender) => {
        this.vessel_holiday_calendars_excel.push({
          sr_no: sr_no,
          vessel: vessel_holiday_calender.vessel
            ? vessel_holiday_calender.vessel.name
            : "",
          holiday_calender_name: vessel_holiday_calender.holiday_calendar
            ? vessel_holiday_calender.holiday_calendar.name
            : "",
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(
            `delete?id=${id}&table_name=vessel_holiday_calendars`
          );
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
